import React from 'react'

import BaseComponent from 'utils/BaseComponent'

import './styles.scss'

export default class NotFound extends BaseComponent {
  render() {
    return(
      <div className="d-flex justify-content-center align-items-center">
        <h1>Esta página no existe</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/NotFound/index.js